<template>
  <div class="container px-0 content-wrapper-p0">
    <div class="payment-layout row checkout-step m-0">
      <div class="col-md-7">
        <div id="paymentForm">
          <div class="main-heading">
            <h1>{{ $t('payment.book_and_pay') }}</h1>
            <p class="checkout-request-subtitle">{{ $t('payment.request_page_subtitle') }}</p>
          </div>
          <div class="act-fast">
            <div class="act-fast-wrapper">
              <span class="SVGIcon SVGIcon--24px SVGIcon--inline">
                <svg data-id="SVG_ALARM__24" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                  fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor"
                    d="M4.37 6.274l1.5-1.5M18.13 4.774l1.5 1.5M14.809 9.53l-2.876 2.874M9.146 12.404H12M18 19.318l-1-1M6.781 18.318l-1 1">
                  </path>
                  <path stroke="currentColor" d="M5.086 12.404a6.914 6.914 0 1113.829.003 6.914 6.914 0 01-13.829-.003z"
                    clip-rule="evenodd"></path>
                  <path fill="currentColor" stroke="none" fill-rule="evenodd"
                    d="M10.75 12.404a1.251 1.251 0 012.5 0 1.25 1.25 0 01-2.5 0z" clip-rule="evenodd"></path>
                </svg>
              </span>
              <span class="inline">
                <strong>{{ $t('payment.act_fast') }} </strong>{{ $t('payment.price_availability') }}
              </span>
            </div>
            <div class="cancellation-tooltip" v-if="$route.params.parrefund">
              <span class="SVGIcon SVGIcon--24px SVGIcon--inline">
                <svg data-id="SVG_DELAY_REFUND_COLOR__24" focusable="false" xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24" stroke="none" fill="none" viewBox="0 0 24 24">
                  <path stroke="#333" d="M8.625 8.597H4.882V4.854"></path>
                  <path stroke="#333" d="M12.375 19.5c4.143 0 7.5-3.357 7.5-7.5A7.499 7.499 0 007.071 6.696L5.179 8.59">
                  </path>
                  <path stroke="none" fill="#333" fill-rule="evenodd"
                    d="M4.875 12.753c-.101 0-.2-.02-.29-.06a.658.658 0 01-.24-.17.73.73 0 01-.16-.81c.03-.09.089-.17.16-.24.07-.07.15-.13.24-.17.189-.07.39-.07.58 0a.807.807 0 01.399.41c.04.09.061.19.061.29 0 .2-.08.39-.22.52a.722.722 0 01-.53.23zM5.225 16.123h.01a.738.738 0 01.27-1.02c.35-.21.81-.09 1.02.27a.75.75 0 01-.65 1.13.758.758 0 01-.65-.38zm3.02 3.02a.742.742 0 01-.27-1.02c.2-.36.66-.49 1.02-.28a.752.752 0 01-.38 1.4.708.708 0 01-.37-.1z"
                    clip-rule="evenodd"></path>
                  <path stroke="#A5C99A"
                    d="M13.81 9.13h-1.944a1.283 1.283 0 00-.478 2.476l1.974.789a1.284 1.284 0 01-.48 2.474h-1.941M12.375 9.13V7.697M12.375 16.304v-1.435">
                  </path>
                </svg>
              </span>
              <span>
                <span>{{ $t('payment.partial_refund') }} </span>
                <div class="" role="button" tabindex="0"
                  style="display: inline-block; outline: 0px; position: relative;">
                  <a> {{ $route.params.prefund }} </a>
                </div>
              </span>
            </div>
          </div>
          <section class="step-section">
            <div class="step-section__wrapper">
              <h3 class="guest-header">{{ $t('payment.contact_information') }}</h3>
              <div class="contact-details checkout-step-section">
                <div class="mandatory-field-info">{{ $t('common.required_field') }}</div>
              </div>
              <div class="row information-form mb-4">
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" v-model="first_name" class="form-control" :placeholder="$t('payment.first_name')"
                      aria-describedby="firstNameError">
                    <div id="firstNameError" v-if="formSubmitted && errors.first_name" class="error-field"
                      style="color: red; font-size: 0.875rem; margin-top: 4px;">{{ errors.first_name }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" v-model="last_name" class="form-control" :placeholder="$t('payment.last_name')"
                      aria-describedby="lastNameError">
                    <div id="lastNameError" v-if="formSubmitted && errors.last_name" class="error-field"
                      style="color: red; font-size: 0.875rem; margin-top: 4px;">{{ errors.last_name }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="email" v-model="email" class="form-control" :placeholder="$t('payment.email')"
                      aria-describedby="emailError">
                    <div id="emailError" v-if="formSubmitted && errors.email" class="error-field"
                      style="color: red; font-size: 0.875rem; margin-top: 4px;">{{ errors.email }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">

                    <!-- <vue-tel-input
                      v-model="phone"
                      class="custom-tel"
                      :preferred-countries="['us', 'gb', 'ca']"
                      :enable-dropdown="true"
                      mode="international"
                      :auto-format="true"
                      default-country="us"
                    /> -->
                    <vue-tel-input v-model="phone" @update="phoneData = $event" @input="onPhoneInput"
                      class="custom-tel-input custom-tel-input--payments"
                      :class="{ 'is-valid': phoneObj.isValid, 'is-invalid': phone && !phoneObj.isValid }"
                      :preferred-countries="['us', 'gb', 'ca']" :enable-dropdown="true" :valid-characters-only="true"
                      :mode="'international'" :disabled-fetching-country="false" :auto-format="true"
                      :validCharactersOnly="true" :default-country="'us'" :input-options="{
                        placeholder: $t('register.enter_phone'),
                        showDialCode: true,
                        tabindex: 0,
                      }" :dropdown-options="{
                        showDialCodeInList: true
                      }" :inputClasses="'form-control'" />
                  </div>
                </div>
              </div>
              <h3 class="guest-header">{{ $t('payment.billing_address') }}</h3>
              <div class="row information-form">
                <div class="col-md-12">
                  <div class="form-group">
                    <input type="text" v-model="country" class="form-control" :placeholder="$t('payment.country')"
                      aria-describedby="countryError">
                    <div id="countryError" v-if="formSubmitted && errors.country" class="error-field"
                      style="color: red; font-size: 0.875rem; margin-top: 4px;">{{ errors.country }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" v-model="zip_code" class="form-control" :placeholder="$t('payment.zip_code')"
                      aria-describedby="zipCodeError">
                    <div id="zipCodeError" v-if="formSubmitted && errors.zip_code" class="error-field"
                      style="color: red; font-size: 0.875rem; margin-top: 4px;">{{ errors.zip_code }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" v-model="state" class="form-control" :placeholder="$t('payment.state')"
                      aria-describedby="stateError">
                    <div id="stateError" v-if="formSubmitted && errors.state" class="error-field"
                      style="color: red; font-size: 0.875rem; margin-top: 4px;">{{ errors.state }}</div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="step-section">
            <div class="step-section__wrapper">
              <div class="row">
                <div class="col-lg-8">
                  <h3 class="guest-header">{{ $t('payment.credit_card_info') }}</h3>
                </div>
                <div class="col-lg-4">
                  <ul class="card-list">
                    <li v-for="brand in cardBrands" :key="brand.name" class="card-item">
                      <img :src="brand.image" :alt="brand.name" class="card-image" />
                    </li>
                  </ul>
                </div>
              </div>
              <div class="contact-details checkout-step-section">
                <div class="mandatory-field-info">{{ $t('common.required_field') }}</div>
              </div>
              <div class="row information-form mb-4">
                <div class="col-md-12">
                  <div class="form-group">
                    <!-- <input type="text" class="form-control" placeholder="Card Holder Name *"> -->
                    <input type="text" id="cardHolderName" class="form-control mb-3"
                      :placeholder="$t('payment.card_holder_name')" v-model="cardHolderName"
                      aria-describedby="cardHolderNameError">
                    <div id="cardHolderNameError" v-if="formSubmitted && errors.cardHolderName" class="error-field"
                      style="color: red; font-size: 0.875rem;">{{ errors.cardHolderName }}</div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <div id="cardElement" class="form-control"></div>
                    <p class="payment-method-note">{{ $t('payment.card_for_request_note') }}</p>
                    <div id="cardErrors" role="alert" v-if="paymentError"
                      style="margin-top: -15px;margin-left: 15px;color: red;">{{ paymentError }}</div>
                    <div id="cardElementError" v-if="formSubmitted && errors.cardElement" class="error-field"
                      style="color: red; font-size: 0.875rem;">{{ errors.cardElement }}</div>
                    <!-- <input type="text" class="form-control" placeholder="Card Number *"> -->
                  </div>
                </div>
                <!-- <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="Expiration MM/YY *">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="tel" class="form-control" placeholder="Security code *">
                  </div>
                </div> -->
              </div>
            </div>
          </section>
          <section class="step-section mt-2">
            <div class="step-section__wrapper">
              <div class="message-to-host">
                <h3>{{ $t('payment.message_to_host') }}</h3><span>{{ $t('payment.message_to_host_subtitle') }}</span>
                <div class="premier-host-badge">
                  <div class="" role="button" tabindex="0" style="display: block; outline: 0px; position: relative;">
                    {{ $t('payment.premier_host') }}</div>
                </div>
                <div class="message-to-host__form">
                  <div class="form-group">
                    <textarea id="message" aria-label="Your message... (optional)" maxlength="3000" rows="3"
                      class="FormTextArea__textarea form-control" :placeholder="$t('payment.optional_message')"
                      spellcheck="false"></textarea>
                  </div>
                </div>
                <p>{{ $t('payment.message_to_host_note') }}</p>
              </div>
            </div>
          </section>
          <!-- <section class="step-section mt-2">
            <div class="step-section__wrapper">
              <h3 class="title">Important information</h3>
              <ul style="list-style: disc;">
                <li><strong>Cancellation Policy: </strong><span key="0">Your booking will not qualify for a refund
                    based on your trip dates.</span></li>
                <li><strong>Age restrictions:</strong> Minimum age to rent is 18.</li>
                <li class="house-rules">
                  <div class="house-rules"><a href="#">Review the house rules.</a>
                    <div></div>
                  </div>
                </li>
              </ul>
            </div>
          </section> -->
          <div class="contact-details-container-outer">
            <div class="contact-details-container-outer__agreement">
              <p>
                {{ $t('payment.confirm_reservation') }}
                <a href="/termsofservice" target="_blank" class="js-eventTracking" data-event-action="terms conditions">
                  {{ $t('form.terms_of_service') }}</a>,
                <a href="/guest-terms-and-conditions" target="_blank" class="js-eventTracking"
                  data-event-action="privacy policy">{{ $t('payment.guest_terms') }}</a>,
                <a href="/cancellation-and-refund-policy" target="_blank" class="js-eventTracking"
                  data-event-action="privacy policy">
                  {{ $t('payment.cancellation_policy') }}</a>
                {{ $t('payment.recurring_billing') }}
              </p>
            </div>
          </div>
          <div class="cta-panel">
            <div class="flex text-center pay-button">
              <!-- <button class="btn btn-primary mt-3" @click="processPayment">{{ $t('payment.pay') }}</button> -->
              <button class="btn btn-primary cta-button btn-lg" data-at-id="contact-continue-button-standard"
                type="button" @click="processPayment" :disabled="isLoading || shouldDisableBooking()">
                <span v-if="isLoading" class="btn__label">
                  <i class="fas fa-spinner fa-spin mr-2"></i>
                  {{ $t('payment.submitting_request') }}
                </span>
                <span v-else class="btn__label" >{{ $t('payment.book_and_pay_now') }}</span>
              </button>
              <div v-if="shouldDisableBooking()" class="demo-property-message" style="color: red; margin-top: 10px; font-size: 14px;">
                {{ $t("common.demo_property_unable_to_book") }}  
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="sidebar-container">
          <div class="listing-info-container">
            <div class="carousel-sec">
              <b-carousel id="carousel-1" v-model="slide[0]" :interval="0" controls indicators background="#ababab"
                img-width="1024" img-height="480" style="text-shadow: 1px 1px 2px #333;"
                @sliding-start="onSlideStart(0)" @sliding-end="onSlideEnd(0)">

                <b-carousel-slide v-for="(property, index) in photos" :key="index">
                  <!-- Wrap the image in a link with Fancybox attributes -->
                  <a :href="property.path" data-fancybox="gallery">
                    <img :src="property.path" alt="image" />
                  </a>
                </b-carousel-slide>
              </b-carousel>
            </div>
            <div class="listing-property-info">
              <div class="property-details">
                <div class="" role="button" tabindex="0" style="display: block; outline: 0px; position: relative;">
                  <h3 class="property-details__headline truncate">{{ $t('property_detail.' + property.property_type) }}</h3>
                </div><span class="property-details__address">{{ property.city }}, {{ property.state }}, {{
                  property.country }}</span>
              </div>
            </div>
            <!-- OLD DATE RANGE START -->
            <!-- <div class="payment-calandar for-custom-style payment-calendar">
              <div class="date-picker">
                <date-range-picker v-model="dateRange" :format="format" :min-date="today">
                  <template v-slot:input="picker" style="min-width: 350px;">
                    <div class="availability-boxes">
                      <div class="box-holder">
                        <span>Check In</span>
                        <div class="box">
                          <p>{{ sdate }}</p>
                        </div>
                      </div>
                      <div class="box-holder">
                        <span>Check Out</span>
                        <div class="box">
                          <p>{{ edate }}</p>
                        </div>
                      </div>
                    </div>
                  </template> </date-range-picker>
</div>
</div> -->
            <!-- OLD DATE RANGE END -->

            <!-- For offer booking, just show static dates -->
            <div class="payment-calandar for-custom-style payment-calendar">
              <div class="date-picker date-field-selection">
                <div v-if="isBookedOffer" class="availability-boxes flex-availability-boxes">
                  <div class="box-holder">
                    <span>{{ $t('Propertis.Check_in') }}</span>
                    <div class="box">
                      <p>{{ sdate }}</p>
                    </div>
                  </div>
                  <div class="box-holder">
                    <span>{{ $t('Propertis.Check_out') }}</span>
                    <div class="box">
                      <p>{{ edate }}</p>
                    </div>
                  </div>
                </div>

                <date-range-picker v-else v-model="dateRange" :format="format" :min-date="today"
                  :date-format="dateFormat" :locale-data="locale_data" :key="localeKey">
                  <template v-slot:input="picker" style="min-width: 350px;">
                    <div class="availability-boxes">
                      <div class="box-holder">
                        <span>{{ $t('Propertis.Check_in') }}</span>
                        <div class="box">
                          <p>{{ sdate }}</p>
                        </div>
                      </div>
                      <div class="box-holder">
                        <span>{{ $t('Propertis.Check_out') }}</span>
                        <div class="box">
                          <p>{{ edate }}</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </date-range-picker>
              </div>
            </div>

            <div class="availability-boxes  guest-availability-box mt-3">
              <div class="box-holder full-width">
                <span>{{ $t('common.guests') }}</span>
                <!-- <div class="box" ref="toggle" @click="togglePopup">
                  <p>{{ guestNumber }} Guests</p>
                </div> -->
                <div class="box" ref="toggle" @click="!isBookedOffer && togglePopup()">
                  <p>{{ guestNumber }} {{ guestNumber === 1 ? $t('Propertis.Guest') : $t('Propertis.Guests') }}</p>
                </div>
              </div>
              <div class="popup-guest" v-if="isPopupVisible && !isBookedOffer" ref="popup">
                <div class="guest-content">
                  <div class="guest-col">
                    <h4 style="margin-right: 10px;">{{ $t('common.adults') }}</h4>
                  </div>
                  <div class="guest-col">
                    <template>
                      <div class="quantity">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-btn variant="info" @click="decrement">-</b-btn>
                          </b-input-group-prepend>

                          <b-form-input type="number" min="1.00" v-model="guestNumber" readonly></b-form-input>

                          <b-input-group-append>
                            <b-btn variant="info" @click="increment">+</b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="guest-content" v-if="property.children !== 'Not Allowed'">
                  <div class="guest-col">
                    <h4 style="margin-right: 10px;">{{ $t('common.child') }}</h4>
                  </div>
                  <div class="guest-col">
                    <template>
                      <div class="quantity">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-btn variant="info" @click="childDecrement">-</b-btn>
                          </b-input-group-prepend>

                          <b-form-input type="number" min="0.00" :value="childQuantity" readonly></b-form-input>

                          <b-input-group-append>
                            <b-btn variant="info" @click="childIncrement">+</b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="guest-content" v-if="property.Pets !== 'Not Allowed'">
                  <div class="guest-col">
                    <h4 style="margin-right: 10px;">{{ $t('common.pets') }}</h4>
                  </div>
                  <div class="guest-col">
                    <template>
                      <div class="quantity">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-btn variant="info" @click="petDecrement">-</b-btn>
                          </b-input-group-prepend>

                          <b-form-input type="number" min="0.00" :value="petQuantity" readonly></b-form-input>

                          <b-input-group-append>
                            <b-btn variant="info" @click="petIncrement">+</b-btn>
                          </b-input-group-append>
                        </b-input-group>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="availability-listing">
              <div class="payment-guide-notice">
                <h4>{{ $t('payment.payment_guide_title') }}</h4>
                <ul class="benefits-list payment-guide-list">
                  <li>{{ $t('payment.request_no_charge_until_accepted') }}</li>
                  <li>{{ $t('payment.request_card_saved_securely') }}</li>
                  <li>{{ $t('payment.request_host_review') }}</li>
                  <li>{{ $t('payment.request_charge_on_accept') }}</li>
                  <li>{{ $t('payment.security_deposit_notice') }}</li>
                  <li>{{ $t('payment.secure_payment') }}</li>
                  <li>{{ $t('payment.support') }}</li>
                </ul>
              </div>
              <div class="price-listing">
                <div class="lisitng-content">
                  
                  <!-- <span>{{ currency }} {{ pfprice }} x {{ ppday
                }} {{ ppday === 1 ? $t('payment.night') :
                      $t('Propertis.nights') }}</span> -->
                      
                      <span>{{ TotalDurationInMonthsAndDays()}}</span>
                      
                      <span>{{ currency }} {{ totaldicPrice1 }}
                      
                  </span></div>
                <div v-if="pfDisprice" class="lisitng-content total-pricing">
                  <h3 class="londis">{{ $t('payment.discounted_amount') }}
                    <span v-if="longdis && longdis !== 0" style="color: #70D3FF;">
                      ( {{ longdis }} % )
                    </span>
                  </h3>
                  <h3 class="price">{{ currency }} {{ formatPrice(discountAmount) }}</h3>
                </div>
                <div class="lisitng-content total-pricing">
                  <h3>{{ $t('payment.monthly_payment') }}</h3>
                  <h3 class="price">{{ currency }} {{ firstMonthPayment.toFixed(0) }}</h3>
                </div>
                <div class="lisitng-content total-pricing">
                  <h3>{{ $t('payment.security_deposit') }}</h3>
                  <h3 class="price">{{ currency }} {{ formatPrice(securityDepositAmount) }}</h3>
                </div>
                <div class="lisitng-content total-pricing security-deposit-charge-total">
                  <h3>{{ $t('payment.charged_on_accept_total') }}</h3>
                  <h3 class="price">{{ currency }} {{ formatPrice(initialChargeOnAccept) }}</h3>
                </div>
                <p class="security-deposit-notice">{{ $t('payment.security_deposit_notice') }}</p>
                <div class="lisitng-content total-pricing">
                  <h3>{{ $t('payment.total_stay') }}</h3>
                  <!-- <h3 class="price">{{ currency }} {{ fprice.toFixed(2) }}</h3> -->
                  <h3 class="price">{{ currency }} {{ formatPrice(tprice) }}</h3>
                </div>

              </div>
              <div v-if="remainingDuration" class="lisitng-content remaining-payment">
                <p>
                  {{ $t('payment.initial_charge_full') }}
                  <strong>{{ currency }} {{ firstMonthPayment.toFixed(0) }}</strong>, 
                  {{ $t('payment.initial_charge_deposit') }} 
                  <strong>{{ currency }} {{ securityDepositAmount.toFixed(0) }}</strong>
                  {{ $t('booking_requests.total') }}
                  <strong>{{ currency }} {{ formatPrice(initialChargeOnAccept) }}.</strong>
                  {{ $t('payment.remaining_amount_prefix') }}
                  <strong>{{ currency }} {{ formatPrice(remainingPayment) }}</strong>
                  {{ $t('payment.remaining_amount_suffix') }}
                  <strong>(for {{ remainingDuration }})</strong>
                  {{ $t('payment.monthly_basis') }}
                </p>
              </div>

            </div>
            <div class="availability-currency">
              <div aria-live="polite" role="alert" class="Alert border--default in Alert--info"><span
                  class="SVGIcon SVGIcon--24px Alert__svg inline-svg text-info"><svg data-id="SVG_INFO__24"
                    v-b-tooltip.hover :title="$t('payment.charged_in_currency',
                      { currency: currency })" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24"
                    height="24" fill="none" viewBox="0 0 24 24">
                    <path fill="currentColor" stroke="none" fill-rule="evenodd" d="M11 7.958a1 1 0 112 0 1 1 0 01-2 0z"
                      clip-rule="evenodd"></path>
                    <path stroke="currentColor" d="M12 16.217v-5.113"></path>
                    <path stroke="currentColor" d="M2.75 12a9.25 9.25 0 1118.502.002A9.25 9.25 0 012.75 12z"
                      clip-rule="evenodd">
                    </path>
                  </svg></span>
                <div class="currency-note-content-line"><span class="currency-note-title-wide">{{
                  $t('payment.charged_in_currency',
                    { currency: currency }) }}</span>
                </div>
                <p class="currency-note-description"></p>
              </div>
            </div>
            <div v-if="discount" class="long_stay_dis discounts-list table-discounts-list">
              <h4>{{ $t('Propertis.discount_on_long_stays') }}</h4>
              <div class="long_dis align-items-center" v-if="discount.oneweekdisc">
                <h5>{{ $t('Propertis.one_week') }} <span class=" ">-{{ discount.oneweekdisc }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.twoweekdisc">
                <h5>{{ $t('Propertis.two_weeks') }} <span class=" ">-{{ discount.twoweekdisc }}%</span></h5>
                <!-- <p><span class="checked-span">-{{ discount.twoweekdisc }}%</span> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.threeweekdisc">
                <h5>{{ $t('Propertis.three_weeks') }} <span class=" ">-{{ discount.threeweekdisc }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.onemonthdis">
                <h5>{{ $t('Propertis.one_month') }} <span class=" ">-{{ discount.onemonthdis }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.twomonthsdis">
                <h5>{{ $t('Propertis.two_months') }} <span class=" ">-{{ discount.twomonthsdis }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.threemonthsdis">
                <h5>{{ $t('Propertis.three_months') }} <span class=" ">-{{ discount.threemonthsdis }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.fourmonthsdis">
                <h5>{{ $t('Propertis.four_months') }} <span class=" ">-{{ discount.fourmonthsdis }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.fivemonthsdis">
                <h5>{{ $t('Propertis.five_months') }} <span class=" ">-{{ discount.fivemonthsdis }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.sixmonthsdis">
                <h5>{{ $t('Propertis.six_months') }} <span class=" ">-{{ discount.sixmonthsdis }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.sevenmonthsdis">
                <h5>{{ $t('Propertis.seven_months') }} <span class=" ">-{{ discount.sevenmonthsdis }}%</span></h5>
                <!-- <p> </p> -->
              </div>
              <div class="long_dis align-items-center" v-if="discount.eightmonthsdis">
                <h5>{{ $t('Propertis.eight_months') }} <span class=" ">-{{ discount.eightmonthsdis }}%</span></h5>
                <!-- <p> </p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { loadStripe } from '@stripe/stripe-js';
// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import API from '@/api';
import axios from 'axios';
import DateRangePicker from 'vue2-daterange-picker';
import moment from 'moment';
import Swal from 'sweetalert2';
import vueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  components: {
    vueTelInput,
    // VuePhoneNumberInput,
    DateRangePicker,
  },
  data() {
    const storedData = localStorage.getItem('paymentFormData');
    let parsedData = null;
    try {
      parsedData = storedData ? JSON.parse(storedData) : null;
    } catch (error) {
      console.error('Error parsing paymentFormData from localStorage:', error);
    }
    const hasRouteParams = this.$route.params.pfprice && this.isValidDateString(this.$route.params.startDate) && this.isValidDateString(this.$route.params.endDate);

    // Initialize dates with today and tomorrow as defaults
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Initialize discountAmount and totaldicPrice1 from stored data or route params
    const initialDiscountAmount = hasRouteParams
      ? this.$route.params.discountAmount
      : (parsedData?.discountAmount || '0.00');
    const initialTotaldicPrice1 = hasRouteParams
      ? this.$route.params.totaldicPrice1
      : (parsedData?.totaldicPrice1 || '0.00');
    const initialPfDisprice = hasRouteParams
      ? parseInt(this.$route.params.pfDisprice)
      : (parsedData?.pfDisprice || 0);

    const longdis = hasRouteParams
      ? parseInt(this.$route.params.longdis)
      : (parsedData?.longdis || null);

    const discountObject = hasRouteParams && this.$route.params.discount_object
      ? JSON.parse(this.$route.params.discount_object)
      : (parsedData?.discount_object || {});

    return {
      locale_data: {},
      phoneObj: {
        number: '',
        isValid: false,
        country: undefined
      },
      localeKey: 0,
      countryCode: '',
      isLoading: false,
      totalPriceParam: '',
      pfprice: hasRouteParams ? this.$route.params.pfprice : (parsedData?.pfprice || 0),
      pffprice: 0,
      today,
      showPicker: false,
      isPopupVisible: false,
      childQuantity: 0,
      petQuantity: 0,
      selectedRegion: '',
      totaldicPrice1: initialTotaldicPrice1,
      discountAmount: initialDiscountAmount,
      pfDisprice: initialPfDisprice,
      longdis,
      discount_object: discountObject,
      guestNumber: hasRouteParams ? this.$route.params.guestnumber : (parsedData?.guestnumber || 2),
      perGuestPrice: hasRouteParams ? this.$route.params.perGuestPrice : (parsedData?.perGuestPrice || 0),
      dateRange: {
        startDate: hasRouteParams
          ? new Date(this.$route.params.startDate)
          : (parsedData?.startDate && this.isValidDateString(parsedData.startDate)
            ? new Date(parsedData.startDate)
            : today),
        endDate: hasRouteParams
          ? new Date(this.$route.params.endDate)
          : (parsedData?.endDate && this.isValidDateString(parsedData.endDate)
            ? new Date(parsedData.endDate)
            : tomorrow),
      },
      isResetting: false, // Flag to suppress watcher during reset
      format: 'YYYY-MM-DD',
      cardBrands: [],
      regions: {
        NorthAmerica: [
          { name: 'Visa', image: 'https://thefinancialtechnologyreport.com/wp-content/uploads/2023/07/VISA.png' },
          { name: 'MasterCard', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdyDpqeooPZc9BzqB4i1hgvjV6UFSGpu8eQE_PGbr2yqudqSsglPYxHk7n4AZlzJsPv2Y&usqp=CAU' },
          { name: 'American Express', image: 'https://www.pay.nl/hubfs/chub_backup/American-Express-Color.png' }
        ],
        Europe: [
          { name: 'Visa', image: 'https://thefinancialtechnologyreport.com/wp-content/uploads/2023/07/VISA.png' },
          { name: 'MasterCard', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdyDpqeooPZc9BzqB4i1hgvjV6UFSGpu8eQE_PGbr2yqudqSsglPYxHk7n4AZlzJsPv2Y&usqp=CAU' },
          { name: 'Maestro', image: 'https://1000logos.net/wp-content/uploads/2020/07/Maestro-Logo-1992.png' }
        ],
        Asia: [
          { name: 'Visa', image: 'https://thefinancialtechnologyreport.com/wp-content/uploads/2023/07/VISA.png' },
          { name: 'MasterCard', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdyDpqeooPZc9BzqB4i1hgvjV6UFSGpu8eQE_PGbr2yqudqSsglPYxHk7n4AZlzJsPv2Y&usqp=CAU' },
          { name: 'JCB', image: 'https://i0.wp.com/mid-east.info/wp-content/uploads/2022/12/jcb.png?fit=745%2C410&ssl=1' },
          { name: 'UnionPay', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR75V7M-jzFROKn_CaNESS7gmAXhGTH0MIslvuC_VHyynhIGwmScOyTkyhkfjifUJiAFB0&usqp=CAU' }
        ],
        SouthAmerica: [
          { name: 'Visa', image: 'https://thefinancialtechnologyreport.com/wp-content/uploads/2023/07/VISA.png' },
          { name: 'MasterCard', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdyDpqeooPZc9BzqB4i1hgvjV6UFSGpu8eQE_PGbr2yqudqSsglPYxHk7n4AZlzJsPv2Y&usqp=CAU' },
          { name: 'American Express', image: 'https://www.pay.nl/hubfs/chub_backup/American-Express-Color.png' }
        ],
        Africa: [
          { name: 'Visa', image: 'https://thefinancialtechnologyreport.com/wp-content/uploads/2023/07/VISA.png' },
          { name: 'MasterCard', image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdyDpqeooPZc9BzqB4i1hgvjV6UFSGpu8eQE_PGbr2yqudqSsglPYxHk7n4AZlzJsPv2Y&usqp=CAU' }
        ]
      },
      updateguest: false,
      updatedates: false,
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      country: '',
      zip_code: '',
      state: '',
      property: [],
      discount: {},
      flashDiscount: {},
      slide: [],
      photos: [],
      cardHolderName: '',
      paymentError: null,
      stripe: null,
      cardElement: null,
      paymentData: {},
      yourValue: '',
      hostFees: '',
      taxfee: '',
      servicefee: '',
      fprice: '',
      sdate: hasRouteParams
        ? this.formatDate(this.$route.params.startDate)
        : (parsedData?.startDate && this.isValidDateString(parsedData.startDate)
          ? this.formatDate(parsedData.startDate)
          : this.formatDate(today)),
      edate: hasRouteParams
        ? this.formatDate(this.$route.params.endDate)
        : (parsedData?.endDate && this.isValidDateString(parsedData.endDate)
          ? this.formatDate(parsedData.endDate)
          : this.formatDate(tomorrow)),
      tprice: hasRouteParams ? this.$route.params.totalPrice1 : (parsedData?.totalPrice1 || 0),
      ppday: hasRouteParams ? this.$route.params.days : (parsedData?.days || 0),
      minDaystoStay: hasRouteParams ? this.$route.params.minDaystoStay : (parsedData?.minDaystoStay || 0),
      maxDaystoStay: hasRouteParams ? this.$route.params.maxDaystoStay : (parsedData?.maxDaystoStay || 0),
      prefund: hasRouteParams ? this.$route.params.prefund : (parsedData?.prefund || ''),
      nrefund: hasRouteParams ? this.$route.params.nrefund : (parsedData?.nrefund || ''),
      parrefund: hasRouteParams ? this.$route.params.parrefund : (parsedData?.parrefund || ''),
      currency: hasRouteParams ? this.$route.params.currency : (parsedData?.currency || 'AED'),
      totalPrice: hasRouteParams ? this.$route.params.totalPrice : (parsedData?.totalPrice || 0),
      offer_id: hasRouteParams ? this.$route.params.offer_id : (parsedData?.offer_id || null),
      is_booked: hasRouteParams
        ? (this.$route.params.is_booked === true || this.$route.params.is_booked === 'true')
        : (parsedData?.is_booked === true || parsedData?.is_booked === 'true' || false),
      remainingPayment: 0,
      remainingMonths: 0,
      extraDaysCharge: 0,
      installments: 0,
      extraDays: 0,
      formSubmitted: false,
      errors: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        country: '',
        zip_code: '',
        state: '',
        cardHolderName: '',
        cardElement: ''
      },
      disabledDates: [],
    };
  },
  computed: {
    isBookedOffer() {
      return this.is_booked === true || this.is_booked === 'true';
    },
    currentOfferId() {
      return this.offer_id || null;
    },
    remainingDuration() {
      const { remainingFullMonths, extraDays } = this;
      if (remainingFullMonths > 0 && extraDays > 0) {
        const monthsText =
          remainingFullMonths === 1
            ? this.$t('common.month_count', { n: remainingFullMonths })
            : this.$t('common.months_count', { n: remainingFullMonths });
        const daysText =
          extraDays === 1
            ? this.$t('common.day_count', { n: extraDays })
            : this.$t('common.days_count', { n: extraDays });
        return this.$t('payment.remaining_duration', {
          months: monthsText,
          days: daysText,
        });
      }
      if (remainingFullMonths > 0) {
        return remainingFullMonths === 1
          ? this.$t('common.month_count', { n: remainingFullMonths })
          : this.$t('common.months_count', { n: remainingFullMonths });
      }
      if (extraDays > 0) {
        return extraDays === 1
          ? this.$t('common.day_count', { n: extraDays })
          : this.$t('common.days_count', { n: extraDays });
      }
      return '';
    },
    securityDepositAmount() {
      if (this.property && this.property.price_per_month) {
        const monthly = parseFloat(String(this.property.price_per_month).replace(/,/g, ''));
        if (!isNaN(monthly) && monthly > 0) {
          return monthly;
        }
      }
      if (this.ppday >= 30) {
        return parseFloat(this.firstMonthPayment) || 0;
      }
      if (this.ppday > 0 && this.fprice) {
        return Math.round((parseFloat(this.fprice) / this.ppday) * 30);
      }
      return parseFloat(this.firstMonthPayment) || 0;
    },
    initialChargeOnAccept() {
      return (parseFloat(this.firstMonthPayment) || 0) + (parseFloat(this.securityDepositAmount) || 0);
    },
    localeData() {
      return {
        applyLabel: this.$t('pagination.apply'),
        cancelLabel: this.$t('pagination.cancel'),
        firstDay: 1,
        format: 'YYYY-MM-DD',
      };
    },
  },
  async mounted() {
    // Initialize SweetAlert2 with high z-index
    Swal.mixin({
      customClass: {
        popup: 'swal2-high-zindex'
      }
    });

    const propertyId = sessionStorage.getItem('propertyId');
    if (propertyId) {
      await this.getProperty(propertyId);
      this.getBookingsByPropertyID(propertyId);
      // Set min and max stay from property data
      this.minDaystoStay = this.property?.min_night_stay || 1;
      this.maxDaystoStay = this.property.max_night_stay || 365;
      // Set pffprice from property data if not already set

      if (!this.pffprice) {
        if (this.property.price_per_month) {
          const monthly = parseFloat(this.property.price_per_month.replace(/,/g, ''));
          this.pffprice = monthly / 30;
        } else if (this.property.price) {
          this.pffprice = parseFloat(this.property.price);
        } else {
          this.pffprice = '0.00';
        }
      }
      this.pfprice = this.pffprice;
    } else {
      console.error('No property ID found in sessionStorage');
    }

    const storedData = localStorage.getItem('paymentFormData');
    let parsedData = null;
    try {
      parsedData = storedData ? JSON.parse(storedData) : null;
    } catch (error) {
      console.error('Error parsing paymentFormData from localStorage:', error);
    }
    
    // Initialize perGuestPrice from stored data or calculate from pffprice
    if (!this.perGuestPrice || this.perGuestPrice === 0) {
      const storedPerGuestPrice = parsedData?.perGuestPrice || this.$route.params.perGuestPrice;
      if (storedPerGuestPrice) {
        this.perGuestPrice = parseFloat(storedPerGuestPrice);
      } else if (this.pffprice && this.guestNumber > 0) {
        this.perGuestPrice = parseFloat(this.pffprice) / this.guestNumber;
      }
    }
    
    if (this.$route.params.pfprice && this.isValidDateString(this.$route.params.startDate) && this.isValidDateString(this.$route.params.endDate)) {
      this.storeRouteParams();
    } else if (parsedData && this.isValidDateString(parsedData.startDate) && this.isValidDateString(parsedData.endDate)) {
      this.discountAmount = parsedData.discountAmount || '0.00';
      this.totaldicPrice1 = parsedData.totaldicPrice1 || '0.00';
      this.pfDisprice = parsedData.pfDisprice || 0;
      this.updateRouteParams({
        startDate: parsedData.startDate,
        endDate: parsedData.endDate,
        totalPrice1: parsedData.totalPrice1,
        days: parsedData.days,
        pfprice: parsedData.pfprice,
        guestnumber: parsedData.guestnumber,
        discountAmount: this.discountAmount,
        totaldicPrice1: this.totaldicPrice1,
        pfDisprice: this.pfDisprice,
        longdis: this.longdis,
        currency: parsedData.currency,
        offer_id: parsedData.offer_id,
        is_booked: parsedData.is_booked,
        discount_object: parsedData.discount_object,
      });
    } else {
      this.resetToDefaultDates();
    }

    this.updateCardBrands();
    this.newfunction();
    this.initializeStripe();

    if (this.isBookedOffer && this.dateRange?.startDate && this.dateRange?.endDate) {
      const startMoment = moment(this.dateRange.startDate);
      const endMoment = moment(this.dateRange.endDate);
      if (startMoment.isValid() && endMoment.isValid()) {
        const days = endMoment.diff(startMoment, 'days');
        const baseTotal = this.pfprice * days;
        this.ppday = days;
        this.calculatePricing(baseTotal, days);
      } else {
        this.resetToDefaultDates();
      }
    }
    if (!this.isBookedOffer) {
      this.$root.$on('currency-changed', (newCurrency) => {
        if (newCurrency !== this.currency) {
          this.recalculatePrices(newCurrency);
        }
      });
    }

    // Listen for clear-dates event from DateRangePicker
    Vue.prototype.$EventBus.$on('clear-dates', () => {
      this.resetDateRange();
    });
    this.updateTranslations();  // Set initial locale_data (months/days for picker)
    this.$nextTick(() => {
      // ... existing $nextTick logic
      // Re-format initial dates to match current locale
      this.sdate = this.formatDate(this.dateRange.startDate);
      this.edate = this.formatDate(this.dateRange.endDate);
    });
    this.$nextTick(() => {
      const storedPfPrice = parsedData?.pfprice ? parseFloat(parsedData.pfprice) : null;
      const storedGuestNumber = parsedData?.guestnumber ? parseInt(parsedData.guestnumber) : null;
      const storedDays = parsedData?.days ? parseInt(parsedData.days) : 1;

      let finalPfPrice = null;
      let finalGuestCount = null;

      if (storedPfPrice !== null && storedGuestNumber !== null && storedGuestNumber > 0) {
        finalPfPrice = parseFloat(storedPfPrice);
        finalGuestCount = storedGuestNumber;
      }
      else if (this.property) {
        if (this.property.price_per_month) {
          const monthly = parseFloat(this.property.price_per_month.replace(/,/g, ''));
          finalPfPrice = monthly / 30;
        } else if (this.property.price) {
          finalPfPrice = parseFloat(this.property.price);
        } else {
          finalPfPrice = '0.00';
        }
        finalGuestCount = this.getDefaultGuestCount();
      }
      else {
        finalPfPrice = '0.00';
        finalGuestCount = 2;
      }

      this.pffprice = finalPfPrice;
      this.guestNumber = finalGuestCount;

      // Initialize perGuestPrice if not already set
      if (!this.perGuestPrice || this.perGuestPrice === 0) {
        this.perGuestPrice = this.pffprice && this.guestNumber > 0 ? parseFloat(this.pffprice) / this.guestNumber : 0;
      }

      this.ppday = storedDays;
      this.pfprice = this.pffprice;
      // Recalculate total
      const baseTotal = this.pffprice * this.ppday;

      this.calculatePricing(baseTotal, this.ppday);

      this.sdate = this.formatDate(this.dateRange.startDate);
      this.edate = this.formatDate(this.dateRange.endDate);
    });
  },
  watch: {
    '$route.params': {
      immediate: true,
      deep: true,
      handler(newParams) {
        if (newParams.pfprice && this.isValidDateString(newParams.startDate) && this.isValidDateString(newParams.endDate)) {
          this.updateFromRouteParams(newParams);
        } else {
          const storedData = localStorage.getItem('paymentFormData');
          if (storedData) {
            try {
              const parsedData = JSON.parse(storedData);
              if (this.isValidDateString(parsedData.startDate) && this.isValidDateString(parsedData.endDate)) {
                this.discountAmount = parsedData.discountAmount || '0.00';
                this.totaldicPrice1 = parsedData.totaldicPrice1 || '0.00';
                this.pfDisprice = parsedData.pfDisprice || 0;
                this.updateFromRouteParams(parsedData);
              } else {
                this.resetToDefaultDates();
              }
            } catch (error) {
              console.error('Error parsing stored data in route params watcher:', error);
              // this.resetToDefaultDates();
            }
          } else {
            this.resetToDefaultDates();
          }
        }
      }
    },
    '$i18n.locale': {
      immediate: true,
      handler(newLang) {
        this.updateTranslations();
        this.localeKey++;
        this.sdate = this.formatDate(this.dateRange.startDate || new Date());
        this.edate = this.formatDate(this.dateRange.endDate || new Date(new Date().setDate(new Date().getDate() + 1)));
        this.newfunction();
      },
    },
    isPopupVisible(visible) {
      if (visible) {
        document.addEventListener("click", this.handleClickOutside);
      } else {
        document.removeEventListener("click", this.handleClickOutside);
      }
    },
    dateRange: {
      deep: true,
      handler(newVal) {
        if (this.isResetting) {
          return;
        }
        if (!newVal || !newVal.startDate || !newVal.endDate || !moment(newVal.startDate).isValid() || !moment(newVal.endDate).isValid()) {
          console.error('Invalid dateRange:', newVal);
          if (this.isBookedOffer) {
            Swal.fire({
              type: 'error',
              title: this.$t('alerts.error'),
              text: this.$t('payment.fixed_dates'),
              confirmButtonText: this.$t('sweetalert.OK'),
              icon: 'error',
              customClass: {
                popup: 'swal2-high-zindex'
              }
            });
            if (this.isValidDateString(this.$route.params.startDate) && this.isValidDateString(this.$route.params.endDate)) {
              this.dateRange = {
                startDate: new Date(this.$route.params.startDate),
                endDate: new Date(this.$route.params.endDate)
              };
              this.sdate = this.formatDate(this.$route.params.startDate);
              this.edate = this.formatDate(this.$route.params.endDate);
            } else {
              this.resetToDefaultDates();
            }
          } else {
            this.resetToDefaultDates();
          }
          return;
        }
        const startMoment = moment(newVal.startDate);
        const endMoment = moment(newVal.endDate);
        this.sdate = this.formatDate(startMoment.toDate());
        this.edate = this.formatDate(endMoment.toDate());
        const differenceInDays = endMoment.diff(startMoment, 'days');

        // Enforce minimum 30-day stay
        if (differenceInDays < 30) {
          Swal.fire({
            type: 'error',
            title: this.$t('alerts.error'),
            text: this.$t('validations.min_stay', { days: 30 }),
            confirmButtonText: this.$t('sweetalert.OK'),
            icon: 'error',
            customClass: {
              popup: 'swal2-high-zindex'
            }
          });
          if (this.isValidDateString(this.$route.params.startDate) && this.isValidDateString(this.$route.params.endDate)) {
            this.dateRange = {
              startDate: new Date(this.$route.params.startDate),
              endDate: new Date(this.$route.params.endDate)
            };
            this.sdate = this.formatDate(this.$route.params.startDate);
            this.edate = this.formatDate(this.$route.params.endDate);
          } else {
            this.resetToDefaultDates();
          }
          if (this.$refs.datePickerRef) {
            this.$refs.datePickerRef.showCalendar = false;
          }
          return;
        }

        if (differenceInDays < this.minDaystoStay || differenceInDays > this.maxDaystoStay) {
          let stayError = '';
          if (differenceInDays < this.minDaystoStay) {
            stayError = this.$t('validations.min_stay', { days: this.minDaystoStay });
          } else {
            stayError = this.$t('validations.max_stay', { days: this.maxDaystoStay });
          }
          Swal.fire({
            type: 'error',
            title: this.$t('alerts.error'),
            text: stayError,
            confirmButtonText: this.$t('sweetalert.OK'),
            icon: 'error',
            customClass: {
              popup: 'swal2-high-zindex'
            }
          });

          if (this.isValidDateString(this.$route.params.startDate) && this.isValidDateString(this.$route.params.endDate)) {
            this.dateRange = {
              startDate: new Date(this.$route.params.startDate),
              endDate: new Date(this.$route.params.endDate)
            };
            this.sdate = this.formatDate(this.$route.params.startDate);
            this.edate = this.formatDate(this.$route.params.endDate);
          } else {
            this.resetToDefaultDates();
          }
          if (this.$refs.datePickerRef) {
            this.$refs.datePickerRef.showCalendar = false;
          }
          return;
        }

        const overlaps = this.checkDateOverlap(startMoment, endMoment);
        if (overlaps) {
          Swal.fire({
            type: 'error',
            title: this.$t('alerts.error'),
            text: this.$t('sweetalert.overlap'),
            confirmButtonText: this.$t('sweetalert.OK'),
            icon: 'error',
            customClass: {
              popup: 'swal2-high-zindex'
            }
          });
          if (this.isValidDateString(this.$route.params.startDate) && this.isValidDateString(this.$route.params.endDate)) {
            this.dateRange = {
              startDate: new Date(this.$route.params.startDate),
              endDate: new Date(this.$route.params.endDate)
            };
            this.sdate = this.formatDate(this.$route.params.startDate);
            this.edate = this.formatDate(this.$route.params.endDate);
          } else {
            this.resetToDefaultDates();
          }
          if (this.$refs.datePickerRef) {
            this.$refs.datePickerRef.showCalendar = false;
          }
          return;
        }

        const tprice1 = this.pfprice * differenceInDays;
        this.ppday = differenceInDays;
        this.calculatePricing(tprice1, differenceInDays);
        this.updatedates = true;
        console.info('On changing booking date', this.tprice);

        this.updateRouteParams({
          startDate: startMoment.format('YYYY-MM-DD'),
          endDate: endMoment.format('YYYY-MM-DD'),
          totalPrice1: this.tprice,
          days: this.ppday,
          pfprice: this.pfprice,
          guestnumber: this.guestNumber,
          discountAmount: this.discountAmount,
          totaldicPrice1: this.totaldicPrice1,
          pfDisprice: this.pfDisprice,
          longdis: this.longdis,
          currency: this.currency,
          offer_id: this.offer_id,
          is_booked: this.is_booked,
          discount_object: this.discount,
        });

        this.newfunction();
      }
    },
  },
  methods: {
    formatPrice(value) {
    const num = parseFloat(value);
    if (isNaN(num)) return '0';
    
    // Convert to 2 decimals, then back to a number to strip trailing .00
    return Number(num.toFixed(2)).toString();
  },
   shouldDisableBooking() {
      const propertyId = sessionStorage.getItem('propertyId');
      //local demo ids
      // const demoIds = [1, 2, 3, 4, 5, 6, 7, 8, 9,10,11,12,13,14,15];  //local demo ids
      const demoIds = [];    //live demo ids
      const status = propertyId ? demoIds.includes(parseInt(propertyId)) : false;
      return status;
    },      
    onPhoneInput(number, phoneObject) {
      // phoneObject contains: isValid, number, country, etc.
      this.phoneObj = phoneObject
      // Optional: update v-model if you want formatted version
      this.phone = phoneObject.number?.international || number
    },

    validatePhone() {
      if (!this.phoneObj?.isValid) {
        this.regMsgTextErr = this.$t('validations.phone')
        return false
      }
      return true
    },
    isValidDateString(dateString) {
      if (!dateString || typeof dateString !== 'string') return false;
      const date = new Date(dateString);
      return !isNaN(date.getTime());
    },
    updateTranslations() {
      // Base structure
      this.locale_data = {
        direction: 'ltr',  // Or 'rtl' for right-to-left languages like Arabic
        // format: this.format,  // Already set as 'YYYY-MM-DD'
        separator: ' - ',
        applyLabel: this.$t('pagination.apply'),  // Or your key for "Apply"
        cancelLabel: this.$t('pagination.cancel'),  // Or your key for "Cancel"
        weekLabel: this.$t('date.week_abbr'),  // e.g., 'W' or translated 'Sem'
        customRangeLabel: this.$t('date.custom_range'),  // e.g., 'Custom Range'
        firstDay: 1,  // 0=Sunday, 1=Monday (adjust per locale, e.g., 5 for Arabic)

        // Translated days (short abbreviations)
        daysOfWeek: [
          this.$t('date.days.sunday_short'),    // e.g., 'Su' or 'dim'
          this.$t('date.days.monday_short'),    // e.g., 'Mo' or 'lun'
          this.$t('date.days.tuesday_short'),   // e.g., 'Tu' or 'mar'
          this.$t('date.days.wednesday_short'), // e.g., 'We' or 'mer'
          this.$t('date.days.thursday_short'),  // e.g., 'Th' or 'jeu'
          this.$t('date.days.friday_short'),    // e.g., 'Fr' or 'ven'
          this.$t('date.days.saturday_short')   // e.g., 'Sa' or 'sam'
        ],

        // Translated full month names
        monthNames: [
          this.$t('date.months.january'),     // e.g., 'January' or 'Janvier'
          this.$t('date.months.february'),    // e.g., 'February' or 'Février'
          this.$t('date.months.march'),       // e.g., 'March' or 'Mars'
          this.$t('date.months.april'),       // e.g., 'April' or 'Avril'
          this.$t('date.months.may'),         // e.g., 'May' or 'Mai'
          this.$t('date.months.june'),        // e.g., 'June' or 'Juin'
          this.$t('date.months.july'),        // e.g., 'July' or 'Juillet'
          this.$t('date.months.august'),      // e.g., 'August' or 'Août'
          this.$t('date.months.september'),   // e.g., 'September' or 'Septembre'
          this.$t('date.months.october'),     // e.g., 'October' or 'Octobre'
          this.$t('date.months.november'),    // e.g., 'November' or 'Novembre'
          this.$t('date.months.december')     // e.g., 'December' or 'Décembre'
        ]
      };
    },
    resetDateRange() {
      if (this.isBookedOffer) {
        Swal.fire({
          type: 'error',
          title: this.$t('alerts.error'),
          text: this.$t('payment.fixed_dates'),
          confirmButtonText: this.$t('sweetalert.OK'),
          icon: 'error',
          customClass: {
            popup: 'swal2-high-zindex'
          }
        });
        return;
      }

      this.isResetting = true; // Suppress watcher validation
      const today = new Date();
     const defaultEndDate = new Date(today);
      defaultEndDate.setDate(
        today.getDate() + (parseInt(this.property?.min_night_stay))
      );
     console.log("this.property?.min_night_stay",this.property?.min_night_stay)
     console.log("this.ppday",this.ppday)

      // Reset date range to today and tomorrow
      this.dateRange = {
        startDate: today,
        endDate: defaultEndDate,
      };
      this.sdate = moment(today).format('DD-MM-YYYY');
      this.edate = moment(defaultEndDate).format('DD-MM-YYYY');
      this.ppday = parseInt(this.property?.min_night_stay);

      // Reset guest-related fields
      this.guestNumber = this.getDefaultGuestCount();
      this.childQuantity = 0;
      this.petQuantity = 0;

      // No per-guest adjustment; pfprice is fixed
      // this.pfprice = Math.round(this.pffprice);
      this.pfprice = parseFloat(this.pffprice);
      this.updateGuestPrice();

      // Reset pricing and discount fields
      const baseTotal = parseFloat(this.pfprice) * this.ppday;
      this.calculatePricing(baseTotal, this.ppday);

      // Reset discount-related fields
      this.discountAmount = '0.00';
      this.totaldicPrice1 = Math.round(baseTotal);
      this.pfDisprice = 0;
      this.longdis = null;

      // Update and close DateRangePicker
      if (this.$refs.datePickerRef) {
        this.$refs.datePickerRef.picker?.setStartDate(today);
        this.$refs.datePickerRef.picker.setEndDate(defaultEndDate);
        this.$refs.datePickerRef.showCalendar = false;
      }

      // Update route params and localStorage
      this.updateRouteParams({
        startDate: moment(today).format('YYYY-MM-DD'),
        endDate: moment(defaultEndDate).format('YYYY-MM-DD'),
        totalPrice1: this.tprice,
        days: this.ppday,
        pfprice: this.pfprice,
        guestnumber: this.guestNumber,
        discountAmount: this.discountAmount,
        totaldicPrice1: this.totaldicPrice1,
        pfDisprice: this.pfDisprice,
        longdis: this.longdis,
        currency: this.currency,
        offer_id: this.offer_id,
        is_booked: this.is_booked,
        discount_object: this.discount,
      });

      this.newfunction();
      this.$nextTick(() => {
        this.isResetting = false; // Re-enable watcher
      });
    },
    // formatDate(date) {
    //   const dateObj = date instanceof Date ? date : new Date(date);
    //   if (isNaN(dateObj.getTime())) {
    //     console.error('Invalid date passed to formatDate:', date);
    //     return '';
    //   }
    //   const options = { month: 'short', day: 'numeric' };
    //   return new Intl.DateTimeFormat('en-US', options).format(dateObj).toUpperCase();
    // },
    formatDate(date) {
      const dateObj = date instanceof Date ? date : new Date(date);
      if (isNaN(dateObj.getTime())) {
        console.error('Invalid date passed to formatDate:', date);
        return '';
      }
      const vueLocale = this.$i18n.locale || 'en';
      const localeMap = {
        'en': 'en-US',      // English US: "Nov 12" (month-day)
        'es': 'es-ES',      // Spanish (general): "12 nov" (day-month)
        'de': 'de-DE',      // Deutsch (German): "12. Nov" (day-month with dot)
        'fr': 'fr-FR',      // French: "12 nov." (day-month, lowercase)
        'nl': 'nl-NL',      // Nederlands (Dutch): "12 nov" (day-month)
        'cn': 'zh-CN',      // Chinese (Simplified): "11月12日" (numeric month + 日)
        'es-ar': 'es-AR',   // Spanish Argentina: "12 nov" (day-month, regional variants)
        'es-mx': 'es-MX',   // Spanish Mexico: "12 nov" (day-month, regional variants)
        'ca': 'ca-ES',      // Català (Catalan): "12 nov" (day-month)
        'it': 'it-IT'       // Italiano (Italian): "12 nov" (day-month)
      };
      let intlLocale = localeMap[vueLocale] || vueLocale;
      const options = {
        month: 'short',
        day: 'numeric'
      };
      return new Intl.DateTimeFormat(intlLocale, options).format(dateObj);
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = this.disabledDates.some(disabledDate => {
          return date.setHours(0, 0, 0, 0) === disabledDate.setHours(0, 0, 0, 0);
        });
      }
      return classes;
    },
    checkDateOverlap(newStartDate, newEndDate) {
      for (const booking of this.disabledDates) {
        const existingStartDate = moment(booking);
        if (
          newStartDate.isBetween(existingStartDate, existingStartDate, undefined, '[]') ||
          newEndDate.isBetween(existingStartDate, existingStartDate, undefined, '[]') ||
          existingStartDate.isBetween(newStartDate, newEndDate, undefined, '[]')
        ) {
          return true;
        }
      }
      return false;
    },
    getBookingsByPropertyID(propertyId) {
      API.getBookingsByPropertyID(propertyId, res => {
        const bookings = res.data.data;
        this.disabledDates = [];
        bookings.forEach(booking => {
          const startDate = new Date(booking.start_date);
          const endDate = new Date(booking.end_date);
          if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
            const datesInRange = this.getDatesInRange(startDate, endDate);
            this.disabledDates = this.disabledDates.concat(datesInRange);
          }
        });
      }, err => {
        console.log(err);
      });
    },
    getDatesInRange(startDate, endDate) {
      const datesInRange = [];
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        datesInRange.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return datesInRange;
    },
    async recalculatePrices(newCurrency) {
      if (this.isBookedOffer) return;

      const oldCurrency = this.currency;
      this.currency = newCurrency;
      await this.convertcurency(this.pfprice, oldCurrency, newCurrency);

      let days = this.ppday;
      const storedData = localStorage.getItem('paymentFormData');
      let parsedData = null;
      try {
        parsedData = storedData ? JSON.parse(storedData) : null;
      } catch (error) {
        console.error('Error parsing paymentFormData in recalculatePrices:', error);
      }
      if (parsedData && parsedData.days) {
        days = parsedData.days;
      }
      this.ppday = days;

      const baseTotal = parseFloat(this.pfprice) * days;
      this.calculatePricing(baseTotal, days);

      this.updateRouteParams({
        startDate: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.dateRange.endDate).format('YYYY-MM-DD'),
        totalPrice1: this.tprice,
        days: this.ppday,
        pfprice: this.pfprice,
        guestnumber: this.guestNumber,
        discountAmount: this.discountAmount,
        totaldicPrice1: this.totaldicPrice1,
        pfDisprice: this.pfDisprice,
        longdis: this.longdis,
        currency: newCurrency,
        offer_id: this.offer_id,
        is_booked: this.is_booked,
        discount_object: this.discount,
      });
    },
    async convertcurency(price, currency, ipCurrency) {
      try {
        const response = await fetch(`https://api.exchangerate-api.com/v4/latest/${currency}`);
        const data = await response.json();
        if (!data.rates || !data.rates[ipCurrency]) {
          throw new Error(this.$t('alerts.error'));
        }
        const rate = data.rates[ipCurrency];
        this.pfprice = Math.round(price * rate);
        this.pffprice = this.pfprice;
        // Always calculate perGuestPrice from the base price (pffprice), not from modified pfprice
        this.perGuestPrice = this.guestNumber > 0 ? parseFloat(this.pffprice) / this.guestNumber : 0;
      } catch (error) {
        console.error('Error fetching currency:', error);
      }
    },
    calculatePricing(totalPriceParam, days) {
      this.hostFees = Math.round(totalPriceParam * 0.06);
      this.taxfee = Math.round(totalPriceParam * 0.06);
      this.servicefee = Math.round(totalPriceParam * 0.05);
      this.fprice = Math.round(totalPriceParam);
      this.ppday = days;

      if (this.ppday >= 30) {
        const daysInMonth = 30;
        const monthlyRate = (parseFloat(this.fprice) / this.ppday) * daysInMonth;
        this.firstMonthPayment = parseFloat(monthlyRate);
        this.remainingPayment = Math.round(parseFloat(this.fprice) - monthlyRate);
        this.remainingFullMonths = Math.floor((this.ppday - daysInMonth) / daysInMonth);
        this.extraDays = (this.ppday - daysInMonth) % daysInMonth;
      } else {
        this.firstMonthPayment = parseFloat(this.fprice);
        this.remainingPayment = '0.00';
        this.remainingFullMonths = 0;
        this.extraDays = 0;
      }

      let discountValue = 0;
      if (days >= 7 && days < 14) {
        discountValue = this.discount_object.oneweekdisc || 0;
      } else if (days >= 14 && days < 21) {
        discountValue = this.discount_object.twoweekdisc || 0;
      } else if (days >= 21 && days < 28) {
        discountValue = this.discount_object.threeweekdisc || 0;
      } else if (days >= 28) {
        let months = Math.floor(days / 30);
        if (this.discount_object) {
          switch (months) {
            case 1:
              discountValue = typeof this.discount_object.onemonthdis === 'number' ? this.discount_object.onemonthdis : 0;
              break;
            case 2:
              discountValue = typeof this.discount_object.twomonthsdis === 'number' ? this.discount_object.twomonthsdis : 0;
              break;
            case 3:
              discountValue = typeof this.discount_object.threemonthsdis === 'number' ? this.discount_object.threemonthsdis : 0;
              break;
            case 4:
              discountValue = typeof this.discount_object.fourmonthsdis === 'number' ? this.discount_object.fourmonthsdis : 0;
              break;
            case 5:
              discountValue = typeof this.discount_object.fivemonthsdis === 'number' ? this.discount_object.fivemonthsdis : 0;
              break;
            case 6:
              discountValue = typeof this.discount_object.sixmonthsdis === 'number' ? this.discount_object.sixmonthsdis : 0;
              break;
            case 7:
              discountValue = typeof this.discount_object.sevenmonthsdis === 'number' ? this.discount_object.sevenmonthsdis : 0;
              break;
            default:
              if (months >= 8) {
                discountValue = typeof this.discount_object.eightmonthsdis === 'number' ? this.discount_object.eightmonthsdis : 0;
              }
          }
        }
      }
      const discountAmount = (totalPriceParam * discountValue) / 100;
      this.discountAmount = Math.round(discountAmount);
      const discountedTotal = totalPriceParam - discountAmount;
      this.totalPrice1 = Math.round(discountedTotal);
      this.tprice = Math.round(discountedTotal);
      this.totaldicPrice1 = Math.round(totalPriceParam);
      this.pfDisprice = discountValue > 0 ? 1 : 0;
    },
    updateFromRouteParams(params) {
      // Use stored perGuestPrice if available, otherwise calculate from pffprice
      // This ensures we always use the original per-guest rate, not a derived one
      if (params.perGuestPrice) {
        this.perGuestPrice = parseFloat(params.perGuestPrice);
      } else if (this.pffprice && params.guestnumber > 0) {
        this.perGuestPrice = parseFloat(this.pffprice) / parseInt(params.guestnumber);
      } else {
        this.perGuestPrice = 0;
      }
      this.pfprice = params.pfprice || 0;
      this.guestNumber = params.guestnumber || this.getDefaultGuestCount();
      this.dateRange = {
        startDate: this.isValidDateString(params.startDate) ? new Date(params.startDate) : new Date(),
        endDate: this.isValidDateString(params.endDate) ? new Date(params.endDate) : new Date(new Date().setDate(new Date().getDate() + 1))
      };
      this.tprice = params.totalPrice1 || 0;
      this.ppday = params.days || 0;
      this.minDaystoStay = params.minDaystoStay || 0;
      this.maxDaystoStay = params.maxDaystoStay || 0;
      this.prefund = params.prefund || '';
      this.nrefund = params.nrefund || '';
      this.parrefund = params.parrefund || '';
      this.currency = params.currency || 'AED';
      this.totalPrice = params.totalPrice || 0;
      this.discountAmount = params.discountAmount || '0.00';
      this.totaldicPrice1 = params.totaldicPrice1 || '0.00';
      this.pfDisprice = parseInt(params.pfDisprice) || 0;
      this.sdate = this.isValidDateString(params.startDate) ? this.formatDate(params.startDate) : this.formatDate(new Date());
      this.edate = this.isValidDateString(params.endDate) ? this.formatDate(params.endDate) : this.formatDate(new Date(new Date().setDate(new Date().getDate() + 1)));
      this.longdis = params.longdis || null;
      this.discount = params.discount_object ? JSON.parse(params.discount_object) : {};
      this.offer_id = params.offer_id || null;
      this.is_booked = params.is_booked === true || params.is_booked === 'true';

      this.storeRouteParams();

      this.$nextTick(() => {
        this.newfunction();
        if (this.$refs.datePickerRef?.picker) {
          this.$refs.datePickerRef.picker.setStartDate(this.dateRange.startDate);
          this.$refs.datePickerRef.picker.setEndDate(this.dateRange.endDate);
          this.$refs.datePickerRef.showCalendar = false;
        }
      });
    },
    updateRouteParams({ startDate, endDate, totalPrice1, days, pfprice, guestnumber, discountAmount, totaldicPrice1, pfDisprice, longdis, currency, offer_id, is_booked, discount_object }) {
      const updatedParams = {
        ...this.$route.params,
        startDate: this.isValidDateString(startDate) ? startDate : moment().format('YYYY-MM-DD'),
        endDate: this.isValidDateString(endDate) ? endDate : moment().add(1, 'days').format('YYYY-MM-DD'),
        totalPrice1,
        days,
        pfprice: pfprice || this.pfprice,
        guestnumber: guestnumber || this.guestNumber,
        perGuestPrice: this.perGuestPrice,
        discountAmount: discountAmount || this.discountAmount,
        totaldicPrice1: totaldicPrice1 || this.totaldicPrice1,
        pfDisprice: pfDisprice !== undefined ? pfDisprice : this.pfDisprice,
        longdis: longdis || this.longdis,
        currency: currency || this.currency,
        offer_id: offer_id !== undefined ? offer_id : this.offer_id,
        is_booked: is_booked !== undefined ? (is_booked === true || is_booked === 'true') : (this.is_booked === true || this.is_booked === 'true'),
      };

      if (discount_object) {
        updatedParams.discount_object = JSON.stringify(discount_object);
      }

      this.$router.replace({
        name: this.$route.name,
        params: updatedParams
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Error updating route:', err);
        }
      });

      this.storeRouteParams();
    },
    storeRouteParams() {
      const paramsToStore = {
        pfprice: this.pfprice,
        guestnumber: this.guestNumber,
        perGuestPrice: this.perGuestPrice,
        startDate: this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
        endDate: this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : moment().add(1, 'days').format('YYYY-MM-DD'),
        totalPrice1: this.tprice,
        days: this.ppday,
        minDaystoStay: this.minDaystoStay,
        maxDaystoStay: this.maxDaystoStay,
        prefund: this.prefund,
        nrefund: this.nrefund,
        parrefund: this.parrefund,
        currency: this.currency,
        totalPrice: this.totalPrice,
        discountAmount: this.discountAmount,
        totaldicPrice1: this.totaldicPrice1,
        pfDisprice: this.pfDisprice,
        longdis: this.longdis,
        offer_id: this.offer_id,
        is_booked: this.is_booked,
        discount_object: this.discount,
      };

      localStorage.setItem('paymentFormData', JSON.stringify(paramsToStore));
    },
    restoreFromLocalStorage() {
      const storedData = localStorage.getItem('paymentFormData');
      if (storedData) {
        try {
          const data = JSON.parse(storedData);
          this.pfprice = data.pfprice || 0;
          this.guestNumber = data.guestnumber || this.getDefaultGuestCount();
          this.dateRange = {
            startDate: data.startDate && this.isValidDateString(data.startDate)
              ? new Date(data.startDate)
              : new Date(),
            endDate: data.endDate && this.isValidDateString(data.endDate)
              ? new Date(data.endDate)
              : new Date(new Date().setDate(new Date().getDate() + 1))
          };
          this.tprice = data.totalPrice1 || 0;
          this.ppday = data.days || 0;
          this.minDaystoStay = data.minDaystoStay || 0;
          this.maxDaystoStay = data.maxDaystoStay || 0;
          this.prefund = data.prefund || '';
          this.nrefund = data.nrefund || '';
          this.parrefund = data.parrefund || '';
          this.currency = data.currency || 'AED';
          this.totalPrice = data.totalPrice || 0;
          this.discountAmount = data.discountAmount || '0.00';
          this.totaldicPrice1 = data.totaldicPrice1 || '0.00';
          this.pfDisprice = data.pfDisprice || 0;
          this.longdis = data.longdis || null;
          this.offer_id = data.offer_id || null;
          this.is_booked = data.is_booked === true || data.is_booked === 'true';
          this.discount = data.discount_object || {};
          this.sdate = this.isValidDateString(data.startDate)
            ? this.formatDate(data.startDate)
            : this.formatDate(new Date());
          this.edate = this.isValidDateString(data.endDate)
            ? this.formatDate(data.endDate)
            : this.formatDate(new Date(new Date().setDate(new Date().getDate() + 1)));

          this.updateRouteParams({
            startDate: this.dateRange.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
            endDate: this.dateRange.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : moment().add(1, 'days').format('YYYY-MM-DD'),
            totalPrice1: this.tprice,
            days: this.ppday,
            pfprice: this.pfprice,
            guestnumber: this.guestNumber,
            discountAmount: this.discountAmount,
            totaldicPrice1: this.totaldicPrice1,
            pfDisprice: this.pfDisprice,
            longdis: this.longdis,
            currency: this.currency,
            offer_id: this.offer_id,
            is_booked: this.is_booked,
            discount_object: this.discount,
          });

          this.$nextTick(() => {
            this.newfunction();
            if (this.$refs.datePickerRef?.picker) {
              this.$refs.datePickerRef.picker.setStartDate(this.dateRange.startDate);
              this.$refs.datePickerRef.picker.setEndDate(this.dateRange.endDate);
              this.$refs.datePickerRef.showCalendar = false;
            }
          });
        } catch (error) {
          console.error('Error parsing stored data:', error);
          this.resetToDefaultDates();
        }
      } else {
        this.resetToDefaultDates();
      }
    },
    resetToDefaultDates() {
      this.isResetting = true;
      const today = new Date();
      const defaultEndDate = new Date(today);
      defaultEndDate.setDate(
        today.getDate() + (parseInt(this.property?.min_night_stay || 1, 10))
      );

     this.dateRange = {
      startDate: today,
      endDate: defaultEndDate,
    };

      this.sdate = this.formatDate(today);
      this.edate = this.formatDate(defaultEndDate);
      this.ppday = parseInt(this.property?.min_night_stay);

      // Reset guest-related fields if not in booked offer mode
      if (!this.isBookedOffer) {
        // Reset to property's default guest count (max_guests) or fallback to 2
        this.guestNumber = this.getDefaultGuestCount();
        this.childQuantity = 0;
        this.petQuantity = 0;
      }

      // Set pfprice to fixed base price (pffprice)
      // this.pfprice = Math.round(this.pffprice);
      this.pfprice = parseFloat(this.pffprice);

      // Calculate pricing with proper base total
      const baseTotal = parseFloat(this.pfprice) * this.ppday;
      this.calculatePricing(baseTotal, this.ppday);

      // Reset discount-related fields
      this.discountAmount = '0.00';
      this.totaldicPrice1 = Math.round(baseTotal);
      this.pfDisprice = 0;
      this.longdis = null;

      this.storeRouteParams();
      if (this.$refs.datePickerRef) {
        this.$refs.datePickerRef.picker?.setStartDate(today);
        this.$refs.datePickerRef.picker?.setEndDate(defaultEndDate);
        this.$refs.datePickerRef.showCalendar = false;
      }
      this.$nextTick(() => {
        this.isResetting = false;
      });
    },
    getDefaultGuestCount() {
      // Get the property's default guest count
      // Use max_guests if available, otherwise fallback to 2
      if (this.property && this.property.max_guests) {
        return parseInt(this.property.max_guests);
      }
      // Fallback to 2 if property data is not available
      return 2;
    },
    setDefaultGuestCountIfNeeded() {
      // Set default guest count if not already set from route params or stored data
      if (!this.$route.params.guestnumber && !localStorage.getItem('paymentFormData')) {
        this.guestNumber = this.getDefaultGuestCount();
        // Recalculate perGuestPrice based on original property price and guest count
        this.perGuestPrice = this.pffprice && this.guestNumber > 0 ? parseFloat(this.pffprice) / this.guestNumber : 0;
        // Update pfprice to reflect the new guest count
        this.pfprice = this.perGuestPrice && this.guestNumber > 0 ? parseFloat(this.perGuestPrice) * this.guestNumber : this.pffprice;
      }
    },
    updateGuestPrice() {
      if (this.isBookedOffer) return;
      if (this.perGuestPrice && this.guestNumber >= 0) {
        this.pfprice = this.perGuestPrice * this.guestNumber;
        const baseTotal = parseFloat(this.pfprice) * this.ppday;
        this.calculatePricing(baseTotal, this.ppday);
        this.updateguest = true;

        this.updateRouteParams({
          startDate: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.dateRange.endDate).format('YYYY-MM-DD'),
          totalPrice1: this.tprice,
          days: this.ppday,
          pfprice: this.pfprice,
          guestnumber: this.guestNumber,
          discountAmount: this.discountAmount,
          totaldicPrice1: this.totaldicPrice1,
          pfDisprice: this.pfDisprice,
          longdis: this.longdis,
          currency: this.currency,
          offer_id: this.offer_id,
          is_booked: this.is_booked,
          discount_object: this.discount,
        });

        this.newfunction();
      } else {
        console.warn('Per-guest price or guest number not available for calculation');
      }
    },
    clearStoredData() {
      localStorage.removeItem('paymentFormData');
    },
    async processPayment() {
      try {
        this.isLoading = true;
        this.paymentError = null;
        this.formSubmitted = true;

        // Validate minimum 30-day stay before proceeding
        const startMoment = moment(this.dateRange.startDate);
        const endMoment = moment(this.dateRange.endDate);
        const differenceInDays = endMoment.diff(startMoment, 'days');
        if (differenceInDays < 30) {
          Swal.fire({
            type: 'error',
            title: this.$t('alerts.error'),
            text: this.$t('validations.min_stay', { days: 30 }),
            confirmButtonText: this.$t('sweetalert.OK'),
            icon: 'error',
            customClass: {
              popup: 'swal2-high-zindex'
            }
          });
          this.isLoading = false;
          this.resetToDefaultDates();
          return;
        }

        if (!this.validateForm()) {
          this.isLoading = false;
          return;
        }

        const { token, error } = await this.stripe.createToken(this.cardElement, {
          name: this.cardHolderName,
        });

        if (error) {
          this.paymentError = this.$t('payment.payment_error', { message: error.message });
          this.isLoading = false;
          return;
        }

        this.cardHolderName = '';
        this.paymentError = null;
        this.formSubmitted = false;
        this.errors = {
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          country: '',
          zip_code: '',
          state: '',
          cardHolderName: '',
          cardElement: ''
        };

        const propertyId = sessionStorage.getItem('propertyId');
        const start_date = this.dateRange?.startDate ? moment(this.dateRange.startDate).format('YYYY-MM-DD') : '';
        const end_date = this.dateRange?.endDate ? moment(this.dateRange.endDate).format('YYYY-MM-DD') : '';
        const discountAmount = this.discountAmount || 0;
        const discountPercentage = this.longdis || 0;

        this.paymentData = {
          propertyId: propertyId,
          token: token,
          startDate: start_date,
          endDate: end_date,
          totalPrice: this.fprice,  
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          phone: this.phone,
          country: this.country,
          state: this.state,
          zip_code: this.zip_code,
          hostFees: this.hostFees,
          taxfee: this.taxfee,
          servicefee: this.servicefee,
          paymentCurrency: this.currency,
          number_of_nights: this.ppday,
          price_per_night: this.pfprice,
          number_of_guests: this.guestNumber,
          adults_count: this.guestNumber,
          prefund: this.prefund,
          nrefund: this.nrefund,
          parrefund: this.parrefund,
          firstPayment: parseFloat(this.firstMonthPayment),
          security_deposit_amount: parseFloat(this.securityDepositAmount),
          remainingBalance: parseFloat(this.remainingPayment),
          installments: this.installments,
          extraDaysCharge: this.extraDaysCharge,
          extraDays: this.extraDays,
          discountAmount: discountAmount,
          discountPercentage: discountPercentage,
          offer_id: this.offer_id,
          is_booked: this.is_booked,
          discount_object: this.discount,
        };
        API.createBookingRequest(this.paymentData, (data) => {
          this.isLoading = false;
          if (data.status === 200) {
            this.clearStoredData();
            sessionStorage.removeItem('propertyId');

            this.$swal({
              icon: 'success',
              type: 'success',
              title: this.$t('ratings_and_reviews.success'),
              text: this.$t('ratings_and_reviews.booking_request_submitted'),
              customClass: {
                popup: 'swal2-high-zindex'
              }
            }).then(() => {
              this.$router.push({ name: 'home' });
            });
          } else {
            this.$swal({
              icon: 'error',
              type: 'error',
              title: this.$t('alerts.error'),
              text: data.message,
              customClass: {
                popup: 'swal2-high-zindex'
              }
            });
          }
        }, (error) => {
          this.isLoading = false;
          this.paymentError = this.$t('payment.payment_error', { message: error.message });
        });
      } catch (error) {
        this.isLoading = false;
        this.paymentError = this.$t('payment.payment_error', { message: error.message || this.$t('alerts.error') });
      }
    },
    validateForm() {
      this.errors = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        country: '',
        zip_code: '',
        state: '',
        cardHolderName: '',
        cardElement: ''
      };
      let isValid = true;

      if (!this.first_name.trim()) {
        this.errors.first_name = this.$t('error_messages.required_field');
        isValid = false;
      }

      if (!this.last_name.trim()) {
        this.errors.last_name = this.$t('error_messages.required_field');
        isValid = false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email.trim()) {
        this.errors.email = this.$t('error_messages.required_field');
        isValid = false;
      } else if (!emailRegex.test(this.email)) {
        this.errors.email = this.$t('validations.v_email');
        isValid = false;
      }

      if (!this.phone) {
        this.errors.phone = this.$t('error_messages.required_field');
        isValid = false;
      } else if (this.phoneData && !this.phoneData.isValid) {
        this.errors.phone = this.$t('validations.phone');
        isValid = false;
      }

      if (!this.country.trim()) {
        this.errors.country = this.$t('error_messages.required_field');
        isValid = false;
      }

      if (!this.zip_code.trim()) {
        this.errors.zip_code = this.$t('validations.zip_code_required');
        isValid = false;
      } else if (!/^\d{5}(-\d{4})?$/.test(this.zip_code.trim())) {
        this.errors.zip_code = this.$t('validations.valid_zip_code');
        isValid = false;
      }

      if (!this.state.trim()) {
        this.errors.state = this.$t('error_messages.required_field');
        isValid = false;
      }

      if (!this.cardHolderName.trim()) {
        this.errors.cardHolderName = this.$t('error_messages.required_field');
        isValid = false;
      }

      if (!this.cardElement || this.cardElement._empty || this.cardElement._invalid) {
        this.errors.cardElement = this.$t('payment.card_error');
        isValid = false;
      }

      return isValid;
    },
    updateCardBrands() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          fetch('https://ipwho.is/' + data.ip)
            .then(response => response.json())
            .then(data => {
              let region = data.timezone.split('/')[0];
              this.cardBrands = this.regions[region] || [];
              this.selectedRegion = region;
            })
            .catch(error => {
              this.cardBrands = this.regions['Europe'];
              this.selectedRegion = 'Europe';
              console.error('Error fetching IP details:', error);
            });
        })
        .catch(error => {
          this.cardBrands = this.regions['Europe'];
          this.selectedRegion = 'Europe';
          console.error('Error fetching IP address:', error);
        });
    },
    togglePopup() {
      this.isPopupVisible = !this.isPopupVisible;
    },
    handleClickOutside(event) {
      const popup = this.$refs.popup;
      const toggle = this.$refs.toggle;
      if (
        popup &&
        !popup.contains(event.target) &&
        toggle &&
        !toggle.contains(event.target)
      ) {
        this.isPopupVisible = false;
      }
    },
    increment() {
      if (this.isBookedOffer) return;
      this.guestNumber++;
      this.updateGuestPrice();
    },
    decrement() {
      if (this.isBookedOffer) return;
      if (this.guestNumber > 1) {
        this.guestNumber--;
        this.updateGuestPrice();
      }
    },
    childIncrement() {
      this.childQuantity++;
    },
    childDecrement() {
      if (this.childQuantity > 0) {
        this.childQuantity--;
      }
    },
    petIncrement() {
      this.petQuantity++;
    },
    petDecrement() {
      if (this.petQuantity > 0) {
        this.petQuantity--;
      }
    },
    fetchCurrency() {
      let cur = localStorage.getItem('currency');
      // IP currency lookup commented out for future use:
      // if (cur) {
      //   this.currency = cur;
      //   setTimeout(() => {
      //     this.convertcurency(this.pfprice, this.currency, this.currency);
      //   }, 2000);
      // } else {
      //   axios.get('https://ipapi.co/currency/')
      //     .then(response => {
      //       this.currency = response.data;
      //       setTimeout(() => {
      //         this.convertcurency(this.pfprice, this.currency, this.currency);
      //       }, 2000);
      //     })
      //     .catch(error => {
      //       this.currency = 'AED';
      //       setTimeout(() => {
      //         this.convertcurency(this.pfprice, this.currency, 'AED');
      //       }, 2000);
      //     });
      // }
      this.currency = cur || 'AED';
      setTimeout(() => {
        this.convertcurency(this.pfprice, this.currency, this.currency);
      }, 2000);
    },
    TotalDurationInMonthsAndDays() {
      const months = Math.floor(this.ppday / 30);
      if (months > 0 && this.extraDays > 0) {
        const monthsText =
          months === 1
            ? this.$t('common.month_count', { n: months })
            : this.$t('common.months_count', { n: months });
        const daysText =
          this.extraDays === 1
            ? this.$t('common.day_count', { n: this.extraDays })
            : this.$t('common.days_count', { n: this.extraDays });
        return this.$t('payment.remaining_duration', {
          months: monthsText,
          days: daysText,
        });
      }
      if (months > 0) {
        return months === 1
          ? this.$t('common.month_count', { n: months })
          : this.$t('common.months_count', { n: months });
      }
      if (this.extraDays > 0) {
        return this.extraDays === 1
          ? this.$t('common.day_count', { n: this.extraDays })
          : this.$t('common.days_count', { n: this.extraDays });
      }
      return '';
    },
    newfunction() {
      const totalPriceParam = parseFloat(this.tprice) || 0;
      this.hostFees = totalPriceParam * 0.06;
      // this.taxfee = this.taxAmount;
      this.taxfee = totalPriceParam * 0.06;
      this.servicefee = totalPriceParam * 0.5;
      this.fprice = totalPriceParam;

      if (this.ppday > 30) {
        const daysInMonth = 30;
        const monthlyRate = (this.fprice / this.ppday) * daysInMonth;
        this.firstMonthPayment = Math.round(monthlyRate);
        const remainingDays = this.ppday - daysInMonth;
        this.remainingFullMonths = Math.floor(remainingDays / daysInMonth);
        this.installments = this.remainingFullMonths;
        const extraDays = remainingDays % daysInMonth;
        this.extraDays = extraDays;
        this.extraDaysCharge = (this.ppday % 30) * (this.fprice / this.ppday);

        this.remainingPayment = Math.round(this.fprice - monthlyRate);

        if (this.remainingFullMonths > 0 && extraDays > 0) {
          this.remainingDuration = this.$t('payment.remaining_duration', { months: this.remainingFullMonths, days: extraDays });
        } else if (this.remainingFullMonths > 0) {
          this.remainingDuration = this.$t('common.months_count', { n: this.remainingFullMonths });
        } else {
          this.remainingDuration = this.$t('common.days_count', { n: extraDays });
        }
      } else {
        this.firstMonthPayment = Math.round(this.fprice);
        this.remainingPayment = 0;
        this.remainingDuration = null;
      }
      // console.log('hostfees : ', this.hostFees, 'taxfee : ', this.taxfee, 'servicefee : ', this.servicefee, 'fprice : ', this.fprice, 'ppday : ', this.ppday, 'tprice : ', this.tprice, 'pfprice: ', this.pfprice);
    },
    onSlideStart(index) {
      this.slide[index] = 0;
    },
    onSlideEnd(index) {
      this.slide[index] = this.properties[index].photos.length - 1;
    },
    getProperty(propertyId) {
      return new Promise((resolve, reject) => {
        API.getProperty(propertyId,
          (res) => {
            this.property = res.data.data;
            this.photos = res.data.data.photos;
            this.discount = res.data.discounts;
            this.flashDiscount = res.data.flashDiscount;
            resolve();
          },
          (err) => {
            console.error('Error fetching property:', err);
            reject(err);
          }
        );
      });
    },
    async initializeStripe() {
      const stripePublishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
      if (!stripePublishableKey) {
        console.error('Missing VUE_APP_STRIPE_PUBLISHABLE_KEY');
        this.$snotify.error(this.$t('payment.stripe_error'));
        return;
      }

      this.stripe = await loadStripe(stripePublishableKey);
      const elements = this.stripe.elements();
      this.cardElement = elements.create('card', {
        'disableLink': true
      });
      this.cardElement.mount('#cardElement');
    },
    onDateRangeUpdate({ startDate, endDate }) {
      this.dateRange = { startDate, endDate };
      if (this.$refs.datePickerRef) {
        this.$refs.datePickerRef.showCalendar = false;
      }
    },
    onDateRangeCancel() {
      this.resetDateRange();
    },
  },
  beforeDestroy() {
    if (this.$route.name === 'home') {
      this.clearStoredData();
    }
    document.removeEventListener("click", this.handleClickOutside);
    this.$root.$off('currency-changed');
    Vue.prototype.$EventBus.$off('clear-dates');
  },
};
</script>

<style scoped>
/* Add any custom styles here */
.security-deposit-notice {
  font-size: 13px;
  color: #555;
  margin: 10px 0 0;
  line-height: 1.5;
}

.security-deposit-charge-total h3 {
  color: #0d6efd;
}

.act-fast {
  display: inline-block;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 12px 10px;
  border: 1px solid #70D3FF;
  background: #70D3FF1A;
  max-width: 400px;
}

:deep(.vue-phone-number-input input) {
  border-color: #D6D6D6 !important;
  border-radius: 10px 0 0 10px !important;
  height: 45px !important;
}

:deep(.input-tel.input-phone-number input) {
  border-radius: 0 10px 10px 0 !important;
}

.checkout-step .form-group label,
.country-selector__label {
  display: none !important;
  padding: 0;
}

#cardElement {
  border: 1px solid #D6D6D6;
  padding: 10px;
  border-radius: 10px;
  padding-top: 15px;
}

div#paymentForm div#cardElement {
  margin-bottom: 20px;
}

div#paymentForm button.btn {
  width: 100%;
  font-size: 18px !important;
}

.container {
  max-width: 1172px;
}

.payment-layout {
  height: 100%;
  display: flex;
  padding-top: 20px;
  justify-content: center;
  align-items: flex-start !important;
}

.action button.add-to-cart {
  width: 100%;
  max-width: 150px;
  border-radius: 10px;
  padding: 15px 0;
}

span.SVGIcon {
  margin-right: 8px;
  vertical-align: middle;
  color: #70D3FF;
}

.act-fast span {
  color: #70D3FF;
}

.main-heading {
  margin-bottom: 16px;
}

.payment-layout h1 {
  width: 100%;
  font-size: 25px;
  margin-bottom: 20px;
}

.step-section {
  display: inline-block;
  width: 100%;
  background-color: #FFFFFF;
  border-top: 1px solid #EBEBEB;
  border-radius: 8px;
}

.step-section .step-section__wrapper {
  margin: 20px 0 0;
}

.step-section .step-section__wrapper h3 {
  font-size: 20px;
  margin-bottom: 16px;
  line-height: 1.625rem;
  font-weight: 700;
  color: #333;
  text-transform: capitalize;
}

.mandatory-field-info {
  margin: 0 0.5rem 1rem 0;
  color: #191E3B;
  font-size: 14px;
}

.message-to-host span {
  font-size: 14px;
}

.message-to-host>.premier-host-badge {
  margin: 16px 0;
}

.premier-host-badge {
  border: 0.5px solid #70D3FF;
  border-radius: 58px;
  font-size: 0.75rem;
  line-height: 16px;
  padding: 1px 8px;
  margin-top: 5px;
  width: fit-content;
  color: #70D3FF;
  background: #70D3FF1A;
}

.premier-host-badge div {
  cursor: auto;
}

.mandatory-field-info:before {
  content: "*";
  color: #A7183C;
  padding-right: 0.25rem;
}

.checkout-step-section .row {
  margin-left: -4px;
  margin-right: -4px;
}

.checkout-step-section .col-xs-6,
.checkout-step-section .col-lg-6,
.checkout-step-section .col-xs-12 {
  padding-left: 4px;
  padding-right: 4px;
}

.checkout-step .form-group {
  margin-bottom: 8px;
}

.form-group.form-floating,
.form-group.form-floating .input-group-wrapper {
  position: relative;
}

.form-floating {
  display: block;
  z-index: 0;
}

input:not(:-webkit-autofill) {
  animation: onAutoFillCancel 0s;
}

.form-control {
  display: block;
  width: 100%;
  height: 46px;
  padding: 5px 15px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5rem;
  color: #333;
  background-color: #fff;
  background-image: none;
  border: 1px solid #D6D6D6;
  border-radius: 10px;
  box-shadow: none;
  outline: none;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}


.table-discounts-list.long_stay_dis .long_dis:nth-child(even) {
  background-color: #ebebeb;
}

.table-discounts-list.long_stay_dis .long_dis {
  margin-bottom: 0px;
  padding: 10px 8px;
}

.table-discounts-list.long_stay_dis .long_dis h5 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table-discounts-list.long_stay_dis .long_dis h5 span {
  font-weight: 500;
}

.form-control:focus,
.form-control:hover {
  border: 1px solid #70d3ff;
}

.form-control::placeholder {
  color: #676A7D;
}

label {
  display: inline-block;
  margin-bottom: 5px;
}

.mandatory-field-indicator label::after {
  content: " *";
  color: #A7183C;
}

.availability-boxes .box-holder.full-width {
  width: 100%;
}

.form-group.form-floating label {
  z-index: 3;
  transition: all 50ms ease-out;
  position: absolute;
  left: 16px;
  font-size: 16px;
  top: 20px;
  pointer-events: none;
  max-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 24px);
  white-space: nowrap;
}

.form-group.form-floating .form-control:focus {
  border-color: #245abc;
  box-shadow: inset 0 0 0 1px #245abc;
}

.form-group.form-floating .form-control:focus+label {
  font-size: 12px;
  top: 5px;
}

.form-group.form-floating.not-empty label {
  font-size: 12px;
  top: 5px;
  left: 16px;
}

.help-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px 0 8px;
  line-height: 16px;
  color: #333;
  font-size: 12px;
}

.has-error .help-block {
  color: #d43626;
  position: relative;
}

span.SVGIcon.cko-validation-checkmark {
  position: absolute;
  top: 18px;
  right: 16px;
  z-index: 2;
}

.contact-details-container-outer__agreement,
.contact-details-container-outer__marketing {
  margin: 24px 0;
  color: #191E3B;
  font-size: 14px;
}

div#paymentForm .cta-panel button.cta-button {
  width: 50%;
  background-color: #70d3ff !important;
  white-space: normal;
  min-height: 56px;
  border-color: #70d3ff;
  position: relative;
  border-radius: 10px !important;
}

.cta-panel {
  padding-top: 0;
  margin-top: 40px;
}

div#paymentForm .cta-panel button.cta-button:hover {
  background-color: #fff !important;
  border-color: #70d3ff !important;
  color: #fff;
}

.sidebar-container--desktop {
  margin-top: 64px;
  position: relative;
  z-index: initial;
  width: 100%;
}

.sidebar-container--desktop .phone-agent-container {
  background-color: #FFFFFF;
  border: 1px solid #DFE0E4;
  border-radius: 8px;
  margin: 0 0 24px 0;
  padding: 16px;
}

.sidebar-container--desktop .phone-agent-icon,
.sidebar-container--desktop .phone-agent-content {
  display: table-cell;
  vertical-align: middle;
  padding-right: 24px;
}

.sidebar-container--desktop .phone-agent-icon svg,
.sidebar-container--desktop .phone-agent-content svg {
  width: 35px;
  height: 35px;
}

.sidebar-container--desktop .customer-number,
.rental-number,
.registration-number {
  margin-top: 10px;
}

.checkout-step .row {
  margin-left: -4px;
  margin-right: -4px;
}

.checkout-step .col-lg-12,
.checkout-step .col-lg-6,
.checkout-step .col-lg-4,
.checkout-step .col-lg-3,
.checkout-step .col-md-12,
.checkout-step .col-md-6,
.checkout-step .col-md-4,
.checkout-step .col-md-3,
.checkout-step .col-sm-12,
.checkout-step .col-sm-6,
.checkout-step .col-sm-4,
.checkout-step .col-sm-3,
.checkout-step .col-xs-12,
.checkout-step .col-xs-6,
.checkout-step .col-md-2 {
  padding-left: 4px;
  padding-right: 4px;
}

.checkout-step section.step-section:first-of-type {
  margin-bottom: 8px;
}

.message-to-host__form .form-group textarea {
  height: 104px;
  padding: 15px;
}

.sidebar-container .listing-info-container {
  border: 1px solid #F9F9F9;
  border-radius: 10px;
  background-color: #F9F9F9;
}

.sidebar-container .carousel .carousel-control-prev,
.sidebar-container .carousel .carousel-control-next {
  display: flex !important;
}

.listing-property-info {
  padding: 15px;
  position: relative;
}

.listing-property-info h3 {
  color: #333;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.listing-property-info {
  font-size: 14px;
  line-height: 1.2;
  font-weight: 300;
}

.availability-boxes {
  margin: 0 15px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  border: 0;
  border-radius: 4px;
  position: relative;
}

.date-picker .vue-daterange-picker .form-control {
  margin-bottom: 15px;
}

.availability-boxes .box {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #D6D6D6;
  border-radius: 10px;
  background: #fff;
}

.availability-boxes .box-holder span {
  font-size: 14px;
  color: #717171;
  margin-bottom: 8px;
  display: block;
}

.payment-calandar .date-picker .vue-daterange-picker .form-control .availability-boxes {
  position: absolute;
  width: 100%;
  left: 0;
  margin: 0;
  top: -1px;
  border: 0;
  padding: 0;
  background: #f9f9f9;
  justify-content: space-between;
}

.availability-boxes .box {
  width: 100%;
  padding: 10px 15px;
}

.availability-boxes .box-holder {
  width: 48%;
}

.payment-calandar .date-picker .vue-daterange-picker .form-control .availability-boxes .box:first-child {
  border-right: 1px solid #908F8F;
}

.availability-boxes .box span {
  font-size: 12px;
  line-height: 1.2;
}

.availability-boxes .box p {
  margin: 0;
  font-size: 15px;
  line-height: 1.4;
}

.availability-listing,
.availability-currency {
  margin: 0 15px 30px;
}

.availability-listing .price-listing .lisitng-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.availability-listing .price-listing .lisitng-content span {
  color: #676A7D;
  font-size: 14px;
  line-height: 20px;
}

.availability-listing .lisitng-content.total-pricing {
  border-bottom: 1px solid #DDDDDE;
  border-top: 1px solid #DDDDDE;
  padding: 16px 0;
}

.availability-listing .lisitng-content.total-pricing h3 {
  color: #676A7D;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.availability-listing .lisitng-content.total-pricing h3.price {
  color: #70D3FF;
}

.availability-currency .Alert {
  display: flex;
}

.availability-currency {
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #70D3FF;
  background: #70D3FF1A;
  color: #70D3FF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.availability-currency .Alert .currency-note-title-wide {
  font-size: 16px;
}

.sidebar-container .carousel-sec {
  border-radius: 20px 20px 0 0;
  overflow: hidden;
}

.btn__label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.fa-spinner {
  margin-right: 8px;
}
</style>
<style scoped>
.container {
  padding: 15px;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.col-lg-8 {
  flex: 2;
}

.col-lg-4 {
  flex: 1;
}

.guest-header {
  margin: 0;
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  list-style: none;
  padding: 0;
  margin: 0;
}

.card-item {
  margin-left: 10px;
  /* Adjust spacing between images as needed */
}

.card-image {
  max-width: 37px;
  /* Adjust the maximum width as needed */
  height: auto;
}

.payment-calandar {
  padding: 0 15px;
}

.payment-calandar .date-picker .daterangepicker.show-weeknumbers,
.payment-calandar .date-picker .daterangepicker {
  min-width: 486px;
}

.popup-guest {
  border: 1px solid rgb(231 231 232);
  border-radius: .5rem;
  background: white;
  box-shadow: 0 2px .75rem rgba(12, 14, 28, .08);
  display: block;
  max-width: 100%;
  margin-left: auto;
  padding: 20px 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  position: absolute;
  top: 64px;
  border-radius: 32px;
  z-index: 9;
}

.guest-content {
  display: flex;
  align-items: center;
  border-right: 0 !important;
  justify-content: space-between;
  width: 100%;
}

.guest-content .guest-col h4 {
  margin: 0;
  font-weight: 400;
  font-size: 15px;
  color: #333;
}

.guest-content .guest-col .input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group-append,
.input-group-prepend {
  background: #ffffff;
  color: #c9c8c8;
  width: auto;
  border: none;
}

.input-group-prepend {
  margin-right: -1px;
}

.guest-content .form-control {
  padding: 0;
  height: 30px;
  border: 0;
  text-align: center;
  width: 60px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

ul.benefits-list {
  padding-top: 15px;
  border-top: 1px solid #DDDDDE;
}

ul.benefits-list li {
  color: #676A7D !important;
  font-size: 14px !important;
  line-height: 20px;
  position: relative;
  padding-left: 20px;
}

ul.benefits-list li::before {
  position: absolute;
  top: 2px;
  left: 2px;
}

.benefits-list {
  list-style: none;
  padding: 0;
}

.benefits-list li {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;
  color: #333;
}

.benefits-list li::before {
  content: '';
  right: 18%;
  top: 56%;
  transform: translateY(-10%) rotate(398deg);
  width: 7px;
  height: 14px;
  border-right: 3px solid #70d3ff;
  border-bottom: 3px solid #70d3ff;
  margin-right: 10px;
}


.information-form .vue-tel-input {
  gap: 5px;
  border: none;
}

@media (max-width: 767px) {
  .availability-boxes .box p {
    font-size: 14px;
  }

  .listing-property-info {
    padding: 20px 15px 30px 15px;
  }

  .payment-calandar {
    padding: 0 15px;
  }

  .availability-boxes,
  .availability-listing,
  .availability-currency {
    margin: 0 15px 30px;
  }

  .payment-layout.row.checkout-step {
    flex-direction: column-reverse;
    row-gap: 50px;
  }
}

@media (max-width: 575px) {
  div#paymentForm .cta-panel button.cta-button {
    width: 75%;
  }
}

.discounts-list .long_dis h5 span {
  color: #70d3ff;
  font-size: 17px;
  font-weight: 900;
  float: right;
}

.long_stay_dis .long_dis p {
  font-size: 15px;
  margin-left: 5px;
}

.long_stay_dis .long_dis p span.checked-span {
  border-bottom: 0;
  width: auto;
  font-size: 12px;
  background: #70d3ff;
  padding: 4px 12px;
  color: #fff;
  position: unset;
  border-radius: 100px;
  height: 32px;
}

.long_stay_dis .long_dis h5,
.long_stay_dis .long_dis p {
  margin-bottom: 0px;
}

.long_stay_dis {
  border: 1px solid #dfe0e4;
  padding: 1.5rem;
  margin: .75rem;
  border-radius: 20px;
}

.long_stay_dis h4 {
  margin: 0 0 15px;
  color: #191e3b;
  font-size: 1.55rem;
  font-weight: 500;
  line-height: 2rem;
  border-bottom: 1px solid #dfe0e4;
  padding-bottom: 10px;
}

.long_stay_dis .long_dis {
  margin-bottom: 15px;
}

.long_stay_dis {
  margin: 0 0 30px;
}

.long_stay_dis {
  padding: 15px;
}

.long_stay_dis h4 {
  font-size: 20px;
  line-height: 1.2;
}

.londis span {
  color: #70D3FF;
}

.form-group {
  position: relative;
}

.form-group .error-field {
  position: absolute;
  left: 0;
  bottom: -17px;
}

.form-group div#MazPhoneNumberInput {
  gap: 0;
}

.flex-availability-boxes {
  margin-left: auto;
  margin-right: auto;
  justify-content: space-between;
}

.checkout-request-subtitle {
  margin-top: 8px;
  margin-bottom: 0;
  color: #555;
  font-size: 1rem;
}

.payment-method-note {
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #555;
}

.payment-guide-notice {
  background: #f0f9ff;
  border: 1px solid #b3e5fc;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.payment-guide-notice h4 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

.payment-guide-list {
  margin-bottom: 0;
}
</style>

